import store from "@/store"
import { RefreshToken } from "./http"

const decodeToken = (token) => {
    try {
        const parts = token.split(".")
        if (parts.length !== 3) return null
        return JSON.parse(atob(parts[1]))
    } catch {
        return null
    }
}

const isTokenExpired = (token) => {
    const decoded = decodeToken(token)
    if (!decoded?.exp) return true
    return decoded.exp * 1000 < Date.now() // Умножаем на 1000, так как exp в секундах
}

export const initAuthCheck = async () => {
    try {
        const userInfo = store.getters.userInfo
        const { accessToken, refreshToken } = userInfo || {}

        // Если нет токена, просто выходим
        if (!accessToken) {
            return true
        }

        // Если access token истек
        if (isTokenExpired(accessToken)) {
            // Если refresh токена нет или он тоже истек, выходим
            if (!refreshToken || isTokenExpired(refreshToken)) {
                store.commit("signOut")
                return false
            }

            // Пытаемся обновить токен
            const isRefreshed = await RefreshToken()
            if (!isRefreshed) {
                store.commit("signOut")
                return false
            }
        }

        return true
    } catch (error) {
        console.error("Ошибка при инициализации авторизации:", error)
        return false
    }
}

export { decodeToken, isTokenExpired }
